import { useGoogleReCaptcha as useReCaptcha } from "react-google-recaptcha-v3";

export function useGoogleReCaptcha() {
  const recaptcha = useReCaptcha();

  if (!recaptcha) {
    return null;
  }

  return async (): Promise<string> => {
    if (!recaptcha.executeRecaptcha) {
      return "";
    }

    try {
      return await recaptcha.executeRecaptcha("form_submission");
    } catch (error) {
      console.error("Error executing reCAPTCHA:", error);
      return "";
    }
  };
}
